/** Used to lookup unminified function names. */
var realNames = {};

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = realNames;
